import React from "react";

function ViewRole({ data }) {
  const formatDateTime = (date) => {
    if (!date) return "-";
    return new Date(date)
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/\//g, "-")
      .replace(",", "");
  };

  // ✅ status is returned as a string "1" — handle both
  const isActive =
    data?.status === 1 ||
    data?.status === "1" ||
    data?.status === true;

  return (
    <div className="card-body">
      <div className="row">
        <div className="col-md-6 mb-3">
          <label>Role Name</label>
          <input
            type="text"
            disabled
            className="form-control"
            value={data?.name || "-"}
          />
        </div>

        <div className="col-md-6 mb-3">
          <label>Department</label>
          <input
            type="text"
            disabled
            className="form-control"
            value={
              data?.department?.name ||
              data?.vendor_department?.name ||
              data?.department_name ||
              "-"
            }
          />
        </div>

        <div className="col-md-6 mb-3">
          <label>Status</label>
          <input
            type="text"
            className="form-control"
            disabled
            value={isActive ? "Active" : "Inactive"}
          />
        </div>

        <div className="col-md-6 mb-3">
          <label>Created At</label>
          <input
            type="text"
            disabled
            className="form-control"
            value={formatDateTime(data?.created_at)}
          />
        </div>

        <div className="col-md-6 mb-3">
          <label>Updated At</label>
          <input
            type="text"
            disabled
            className="form-control"
            value={formatDateTime(data?.updated_at)}
          />
        </div>
      </div>
    </div>
  );
}

export default ViewRole;